import { NgModule } from '@angular/core';
import { Route, RouterModule, Routes } from '@angular/router';
import { GatewayComponent } from './routes/gateway/gateway.component';
import { AppListComponent } from './routes/app-list/app-list.component';
import { AppAddComponent } from './routes/app-add/app-add.component';
import { AppDetailComponent } from './routes/app-detail/app-detail.component';
import { InfoComponent } from './routes/info/info.component';
import { DialComponent } from './routes/dial/dial.component';
import { LoginComponent } from './routes/login/login.component';
import { OpenidComponent } from './routes/openid/openid.component';
import { UserGuard } from './guards/user.guard';
import { RoleGuard } from './guards/role.guard';
import { PublicGatewayComponent } from './routes/public-gateway/public-gateway.component';

export type RouteRole = 
'Admin'
| 'Guest';

// export interface RoutePermissions {
//   Permissions: RouteRole[];
// }

export interface RoutePermissions {
  title: string;
  Permissions?: RouteRole[];
}

export interface TypedRoute extends Route {
  data?: RoutePermissions;
}

const routes: Routes = [
  { component: InfoComponent, path: "", data: { title: 'Home' }  },

  { component: LoginComponent, path: 'login',  data: { title: 'Login' }},
  { component: OpenidComponent, path: 'openid',  data: { title: 'Daimler ID' }},
  { component: PublicGatewayComponent, path: 'publicgateway',  canActivate: [UserGuard] },
  { component: DialComponent, path: "dial", canActivate: [UserGuard] },
  
  /* ADMIN ROUTES */
  { component: GatewayComponent, path: "admin/gateway",data: { title: 'Gateway', Permissions: ['Admin'] }, canActivate: [RoleGuard]  },
  { component: AppListComponent, path: "admin/apps",data: { title: 'App List', Permissions: ['Admin'] }, canActivate: [RoleGuard]  },
  { component: AppAddComponent, path: "admin/apps/add",data: { title: 'App Add', Permissions: ['Admin'] }, canActivate: [RoleGuard]  },
  { component: AppDetailComponent, path: "admin/apps/detail/:id", data: { title: 'App Detail', Permissions: ['Admin'] }, canActivate: [RoleGuard]  },

  { path: '**', redirectTo: "404" },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
